/**
 * This file is responsible for rendering the 404 page in the application.
 *
 * The Page404 component from '~/ui/pages/Page404' is used to render the 404 page content.
 *
 */

import { GetStaticProps } from 'next';
import { SSRConfig } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import { Page404 } from 'hah-fe-core/dist/components';

const NotFoundPage = () => <Page404 />;

// eslint-disable-next-line consistent-return
export const getStaticProps: GetStaticProps<SSRConfig> = async ({ locale }) => {
  try {
    return {
      props: {
        ...(await serverSideTranslations(locale)),
        error: null,
      },
    };
  } catch (error) {
    console.log(`Error in getStaticProps:  at ${new Date().toISOString()}`, error);
  }
};

export default NotFoundPage;
